module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-9-b69b66384540af4c4000c0e5fa64692b.svg";